import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import { Item } from '../../../../components/Grid';
import HistoryRowControls from '../../../../components/HistoryRowControls';
import HistoryRowListing from '../../../../components/HistoryRowListing';
import HistorySection from '../../../../components/HistorySection';

import { formatPartialDate } from 'Utility/date';
import DocumentCreationButton from '../../../../components/DocumentCreationButton';

const OCTSCAN = ({ documents, startEdit }: IOwnProps): React.JSX.Element => {
  return (
    <HistorySection
      headerText={<FormattedMessage id={'clinicalstudy.octscan'} />}
      newButton={
        <DocumentCreationButton
          name="octscan"
          text={'clinicalstudy.newoctscan'}
          onClick={startEdit({}, 'octscan')}
          width={15}
          height={3}
          fontSize={14}
          alternate={true}
        />
      }
    >
      <HistoryRowListing
        documents={documents}
        headers={
          <>
            <Item xs={2}>
              <FormattedMessage id={'general.date'} />
            </Item>
            <Item xs={2}>
              <FormattedMessage id={'clinicalstudy.result'} />
            </Item>
            <Item xs={6} />
          </>
        }
        contentFormat={(d: IOCTSCAN): React.JSX.Element => (
          <>
            <Item xs={2} style={{ fontWeight: '600' }}>
              {formatPartialDate(d?.date ?? undefined)}
            </Item>
            <Item xs={2}>
              {d?.result ? <FormattedMessage id={`clinicalstudy.opts.normalAbnormal.${d.result}`} /> : '-'}
            </Item>
            <Item xs={2}>&nbsp;</Item>
            <Item xs={3}>&nbsp;</Item>
            <Item xs={3}>
              <HistoryRowControls document={d} startEdit={startEdit} />
            </Item>
          </>
        )}
      />
    </HistorySection>
  );
};

interface IOwnProps {
  documents: IOCTSCAN[];
  startEdit: (document: TAnyObject, name?: string) => (e: React.MouseEvent<Element, MouseEvent>) => void;
}

export default OCTSCAN;
